import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { connect } from 'react-redux'
import classnames from 'classnames'

import Loader from 'components/loader'

import styles from './iframe-page.css'

let iframeTimeout = 0

export class IframePage extends Component {

  constructor() {
    super()
    this.onIframeLoad = this.onIframeLoad.bind(this)
    this.state = {
      loaded: false,
      iframeHeight: 0,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.setState({ loaded: false })
    }
  }

  componentWillUnmount() {
    clearTimeout(iframeTimeout)
  }

  onIframeLoad() {
    this.setState({ loaded: true }, this.updateScrollHeight)
  }

  updateScrollHeight() {
    const { iframe } = this.refs

    clearTimeout(iframeTimeout)

    if (this.state.loaded &&
      iframe &&
      iframe.contentWindow &&
      iframe.contentWindow.document &&
      iframe.contentWindow.document.body
    ) {
      const height = iframe.contentWindow.document.body.scrollHeight

      this.setState({ iframeHeight: height })

      iframeTimeout = setTimeout(() => this.updateScrollHeight(), height === 0 ? 200 : 2000)
    }
  }

  hasLoaded() {
    return this.state.loaded
  }

  render() {
    const { location } = this.props
    const style = {
      height: `${this.state.iframeHeight}px`,
    }

    return (
      <div styleName="page">
        {!this.hasLoaded() &&
          <div styleName="centered">
            <Loader center />
          </div>
        }
        <iframe
          key={location.pathname}
          ref="iframe"
          src={`${location.pathname}?inline=1`}
          scrolling="no"
          style={style}
          styleName={classnames('iframe', { 'iframe--loading': !this.hasLoaded() })}
          onLoad={this.onIframeLoad}
        ></iframe>
      </div>
    )
  }

}

IframePage.propTypes = {
  location: PropTypes.object,
}

export default connect()(CSSModules(IframePage, styles, { allowMultiple: true }))



/** WEBPACK FOOTER **
 ** ./src/containers/iframe-page/iframe-page.js
 **/